import { render, staticRenderFns } from "./LoadingWrapper.vue?vue&type=template&id=cafd5722&scoped=true&lang=pug"
import script from "./LoadingWrapper.vue?vue&type=script&lang=js"
export * from "./LoadingWrapper.vue?vue&type=script&lang=js"
import style0 from "./LoadingWrapper.vue?vue&type=style&index=0&id=cafd5722&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafd5722",
  null
  
)

export default component.exports